module.exports = "/_next/static/files/c2ecb46aa5baee849c4f748d9c93279e.png";